import { Grid, GridItem } from "@chakra-ui/react";
import { useContext } from "react";

import { HEADING_STYLES } from "@nens/ranalib";
import { TenantContext } from "@nens/ranalib";

import { ImproveRanaOverviewBlock } from "@/components/improve-rana-overview-block";
import { useInvitationAccept } from "@/lib/auth";

import { DownloadDesktopRanaBlock } from "./components/download-desktop-block";
import { LatestActivitiesBlock } from "./components/latest-activities-block";
import { MyProjectsBlock } from "./components/my-projects-block";
import { UserWelcomeBlock } from "./components/user-welcome-block";
import { WhatsNewBlock } from "./components/whats-new-block";

export const DASHBOARD_GRID_ITEM_HEIGHT = "2xs";

const EmptyBlock = () => {
  return <GridItem sx={{ display: { base: "none", md: "block" } }} />;
};

export function TenantDetails() {
  const { user, tenant } = useContext(TenantContext);

  // Accept the invitation hook
  useInvitationAccept();

  return (
    <Grid
      mt={HEADING_STYLES.sizes.h1.lineHeight}
      templateColumns={{ base: "repeat(1, 100%)", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }}
      gap={4}
    >
      <UserWelcomeBlock {...{ user }} />
      <MyProjectsBlock {...{ tenant, user }} />
      <LatestActivitiesBlock />
      <WhatsNewBlock />
      <ImproveRanaOverviewBlock />
      <EmptyBlock />
      <EmptyBlock />
      <DownloadDesktopRanaBlock />
    </Grid>
  );
}
